<template lang="pug">
.menu-container
  template(v-if="coin")
    .menu.coin
      .left
        div.button.is-text(@click="goTo('/')", :class="{'top-menu-selected': pageSelected === 'start'}") Start
        div.button.is-text(@click="goTo('/account')", :class="{'top-menu-selected': pageSelected === 'account'}") Account
        div.button.is-text(@click="goTo('/address')", :class="{'top-menu-selected': pageSelected === 'address'}") Address
        div.button.is-text(@click="goTo('/referrals')", :class="{'top-menu-selected': pageSelected === 'referral'}") Referrals
        //- a.button.is-text.is-trx-menu(v-if="coin === 'TRX'" href='https://unmineable.com/support/article/tron-mining-what-are-the-sr-super-representative-rewards/') SR
        div.button.is-text.margin-top-mobile-486(@click="goTo('/support')", :class="{'top-menu-selected': pageSelected === 'support'}") Support
        div.button.is-text.app-menu-item.hint--top(@click="goTo('/app')", :class="{'top-menu-selected': pageSelected === 'app'}", aria-label="Easy monitoring from your pocket")
          i.fa.fa-mobile
          span App
        //- div.button.is-text.download-top.margin-top-mobile(@click="goTo('/start')") 
        div.button.is-text.hint--top.download-top.margin-top-mobile(@click="goTo('/start')", aria-label="For beginners and experienced miners") 
          b Get started  🚀
        div.button.is-text.mode-selector.hint--top(
          aria-label='Toggle light / dark theme', 
          :data-mode="mode",
          @click="toggleMode"
        )
          i.fa(:class="{'fa-moon-o': mode === 'light', 'fa-lightbulb-o': mode === 'dark'}")

      //- .right
        //- a.mode-selector.hint--left(
        //-   aria-label='Toggle light / dark theme', 
        //-   :data-mode="mode",
        //-   @click="toggleMode"
        //- )
        //-   i.fa(:class="{'fa-moon-o': mode === 'light', 'fa-lightbulb-o': mode === 'dark'}")
        //- router-link.button.hint--left.coin-selector(aria-label='Change coin', to='/coins')
          span.icon.is-small
            img(:src="coinLogo", :alt="coin + ' icon'")
          span.label- {{ coin }}
  template(v-else)
    .menu.no-coin.has-text-centered
      div.button.is-text(@click="goTo('/referrals')", :class="{'top-menu-selected': pageSelected === 'referral'}") Referrals
      //- div.button.is-text(@click="goTo('/coins')", :class="{'top-menu-selected': pageSelected === 'coins'}") Coins
      div.button.is-text(@click="goTo('/support')", :class="{'top-menu-selected': pageSelected === 'support'}") Support
      div.button.is-text.app-menu-item.hint--top(@click="goTo('/app')", :class="{'top-menu-selected': pageSelected === 'app'}", aria-label="Easy monitoring from your pocket")
        i.fa.fa-mobile
        span App
      div.button.is-text.hint--top.download-top(@click="goTo('/start')", aria-label="For beginners and experienced miners") 
        b Get started
          
</template>

<script>
export default {
  name: 'c_top_bar',
  data() {
    return {
    }
  },
  computed: {
    coin() {
      return this.$store.getters.coinSymbol
    },
    coinLogo() {
      return this.$store.getters.coinData.logo
    },
    pageSelected() {
      return this.$store.getters.pageSelected
    },
    mode() {
      return this.$store.getters.mode
    }
  },
  created() {
  },
  methods: {
    goTo(path) {
      let vm = this
      vm.$emit('go', path)
    },
    toggleMode() {
      let vm = this
      let mode = vm.mode === 'light' ? 'dark' : 'light'
      if (mode === 'dark') {
        document.querySelector('html').classList.add('dark');
      } else {
        document.querySelector('html').classList.remove('dark');
      }
      vm.$store.dispatch('setMode', mode)
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-container
  max-width: 1080px;
  margin: auto;
  .mode-selector
    color: #000;
  .download-top
    background-color #b6ffb6
    &:hover
      background-color #b6ffb6
  .menu
    display flex
    width: 100%
    text-align: left
    position relative
    .button.mode-selector i
      font-size: 15px;
      line-height: 20px;
    .field-top-search
      position absolute
      right 0px
      top 0px
    .button
      font-size: 13px
      margin: 0px 2.5px
      outline: none
      &:focus
        outline: none
        box-shadow: none;
      &.is-text
        text-decoration: none;
      &.sr
        font-weight bold
    .left
      flex 1
      display flex
      justify-content start
      flex-wrap wrap
    .right
      display flex 
      align-items start
      font-family: 'Poppins', sans-serif;
      span
        vertical-align: middle
      .icon:first-child:not(:last-child)
        margin-right: 10px;
      .label-
        font-size: 13px;
      .mode-selector
        line-height: 29px;
        padding: 0px 10px;
        margin-top 1px
        i
          font-size: 18px;
    &.no-coin
      justify-content center
      flex-wrap wrap

.top-menu-selected
  background-color: #f5f5f5 !important;
  color: #363636 !important;

.app-menu-item
  display flex
  i
    font-size 16px
    margin-right 5px

@media (max-width: 625px)
  .menu-container
    .menu 
      .button
        margin-top 10px
      .right
        .mode-selector
          margin-top 11px

html.dark, body.dark
  .menu-container
    .mode-selector
      color: #fff;
      &:hover
        color: #000;
    .coin-selector
      color: #000;
</style>



// WEBPACK FOOTER //
// c_top_bar.vue?2eb460f8